import { useState } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { waLink } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GUEST_COUNTS = ["50–100", "100–250", "250–500", "500–1000", "1000+"];
const EVENT_TYPES = ["Wedding", "Party", "Corporate", "Social", "Other"];

export const LeadGenerator = () => {
  const [guests, setGuests] = useState("");
  const [eventType, setEventType] = useState("");

  const submit = () => {
    if (!guests || !eventType) return;
    window.open(
      waLink(`Hi Momay Caterers, I'm planning a ${eventType} for about ${guests} guests. Please help me plan the catering.`),
      "_blank",
      "noopener"
    );
    axios.post(`${API}/enquiries`, {
      name: "Website Visitor",
      phone: "",
      event_type: eventType,
      guests,
      message: `Quick plan request: ${eventType}, approx ${guests} guests.`,
      source: "lead_generator",
    }).catch(() => {});
  };

  return (
    <section id="plan" data-testid="lead-generator-section" className="bg-cream py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">
        <SectionHeading chapter="10" eyebrow="Start Here" title="Not Sure Where" script="to start?" align="center" />
        <Reveal delay={0.1}>
          <p className="mt-6 text-espresso/60 font-light">Tell us your guest count and event type. We'll help you plan your catering.</p>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <p className="text-[10px] tracking-[0.3em] uppercase text-gold-dark mb-4">Guest Count</p>
          <div className="flex flex-wrap justify-center gap-3">
            {GUEST_COUNTS.map((g) => (
              <button
                key={g}
                data-testid={`lead-guests-${g.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                onClick={() => setGuests(g)}
                className={`px-6 py-3 font-serif text-xl border transition-all duration-300 ${
                  guests === g ? "border-espresso bg-espresso text-gold" : "border-espresso/20 text-espresso/70 hover:border-gold"
                }`}
              >
                {g}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2} className="mt-10">
          <p className="text-[10px] tracking-[0.3em] uppercase text-gold-dark mb-4">Event Type</p>
          <div className="flex flex-wrap justify-center gap-3">
            {EVENT_TYPES.map((t) => (
              <button
                key={t}
                data-testid={`lead-event-${t.toLowerCase()}`}
                onClick={() => setEventType(t)}
                className={`px-6 py-3 text-xs tracking-[0.2em] uppercase border transition-all duration-300 ${
                  eventType === t ? "border-espresso bg-espresso text-gold" : "border-espresso/20 text-espresso/70 hover:border-gold"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.25} className="mt-12">
          <button
            data-testid="lead-submit-btn"
            onClick={submit}
            disabled={!guests || !eventType}
            className="group inline-flex items-center gap-3 bg-gold text-espresso px-10 py-5 text-xs md:text-sm tracking-[0.3em] uppercase font-medium hover:bg-espresso hover:text-gold transition-colors duration-300 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Help Me Plan
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
